/**
 * Integrations API Service
 *
 * Type-safe integration management using openapi-fetch typed client.
 * Types derived from platform-admin.openapi.yaml -- no manual interfaces.
 *
 * Sprint C17+1 (2026-05-04): /data-providers endpoints removed alongside
 * the deprecated PlatformDataProvider model. Switched listThirdParty to
 * the canonical /integrations/third-party endpoint introduced in C17 so
 * the admin-portal CustodianStatus + IntegrationsConfig screens see
 * third-party integrations (not Aaim internal services).
 *
 * Endpoints consumed:
 *   GET  /integrations                          - List all integrations (mixed)
 *   GET  /integrations/third-party              - List third-party (non-Aaim) integrations
 *   GET  /integrations/{integrationId}          - Integration detail
 *   POST /integrations/{integrationId}/test     - Test connection
 */

import { platformAdminClient } from '../client';
import type { components } from '@aaimplatform/institutional-types/platform-admin';

export type Integration = components['schemas']['Integration'];
export type IntegrationDetail = components['schemas']['IntegrationDetail'];

// Backward-compat alias for index.ts re-exports.
export type ThirdPartyIntegration = Integration;

export const integrationsApi = {
  listThirdParty: async (): Promise<Integration[]> => {
    const { data, error } = await platformAdminClient.GET('/integrations/third-party');
    if (error) throw new Error('Failed to fetch third-party integrations');
    return data;
  },

  refreshThirdParty: async (id: string): Promise<void> => {
    const { error } = await platformAdminClient.POST('/integrations/{integrationId}/test', {
      params: { path: { integrationId: id } },
    });
    if (error) throw new Error('Failed to refresh integration');
  },
};
